import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonHeader, IonFooter, IonContent, IonItem } from '@ionic/react';
import ReactDOM from 'react-dom';


import { ShowProductPicsModal } from './Modal_ShowProductPics';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { ViewInvoiceModal } from '../../../zInternal_Features/merchant/components/Modal_ViewInvoice';
import { ViewItemDetailDataModal } from './Modal_Item_Details';

//import '../../../../css/qavaApp.css';
import '../../../css/layout.css'


export function Modal_IngredientList (props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [startDate, setStartDate] = useState(props.startDate);
    let [endDate, setEndDate] = useState(props.endDate);

    let [ingredientID, setIngredientID] = useState('');
    let [ingredientName, setIngredientName] = useState('');
    
    let [checkInModal_tracker, setCheckInModal_tracker] = useState(null);
    
    let [viewInventoryAvailableProducts, setViewInventoryAvailableProducts] = useState([]);
    let [viewInventoryAvailableProducts_food, setViewInventoryAvailableProducts_food] = useState([]);
    let [viewInventoryAvailableProducts_drinks, setViewInventoryAvailableProducts_drinks] = useState([]);
    let [viewInventoryAvailableProducts_hotel, setViewInventoryAvailableProducts_hotel] = useState([]);
    let [viewInventoryAvailableProducts_misc, setViewInventoryAvailableProducts_misc] = useState([]);

    let [viewFood, setViewFood] = useState(true);
    let [viewFoodBorder, setViewFoodBorder] = useState('2px solid black');
    let [viewDrinks, setViewDrinks] = useState(false);
    let [viewDrinkBorder, setViewDrinkBorder] = useState('none');
    let [viewHotel, setViewHotel] = useState(false);
    let [viewHotelBorder, setViewHotelBorder] = useState('none');
    let [viewMisc, setViewMisc] = useState(false);
    let [viewMiscBorder, setViewMiscBorder] = useState('none');

    let [orderID, setOrderID] = useState(null);
    let [orderTotal, setOrderTotal] = useState(null);
    let [invoiceForm, setInvoiceForm] = useState(null);
    let [showInvoiceModal, setViewInvoiceModal] = useState(null);
    let [productPic3, setProductPic3] = useState(null);
    let [productPic4, setProductPic4] = useState(null);
    
    let [showItemDetails, setShowItemDetails] = useState(false);
    
    function getItems_all() {

        const requestOptions = {
                method: 'POST',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                },
                body: JSON.stringify({
                    Tracker: '74401_retrieveingredient_list',
                    user: acctID,
                    sessionID: sessionID,
                }),
            };
    
            fetch(baseURL + 'hotel_merchantAcct_argsjqApp', requestOptions)
                .then(res => res.text())
                .then(res => {
                    let rows = res.toString().split('~~~');
    
                    for (let rownum = 0; rownum < rows.length - 1; ++rownum) {
                        let cols = rows[rownum].split('|');

                        setViewInventoryAvailableProducts((prevAvailableProducts) => {
                            return prevAvailableProducts.concat({
                                ingredientID: cols[0],
                                ingredientName: cols[1],
                                ingredientDescription: cols[2],
                                ingredientPartNum: cols[3],
                                ingredientVendorName: cols[4],
                                ingredientPhoneNumber: cols[5],
                                ingredientAddress: cols[6],
                                ingredientCity: cols[7],
                                ingredientCountry: cols[8],
                                ingredientCostPerUnit: parseFloat(cols[9]).toFixed(2),
                                //ingredientSalePrice: cols[10],
                                ingredientQtyInStock: cols[10],
                                ingredientMeasurementType: parseFloat(cols[11]).toFixed(2),
                                ingredientDateCreated: parseFloat(cols[12]).toFixed(2),
                                ingredientAddedBy: cols[13],
                            });
                        });
                    }
                });
    }

    function getItems_food(item_type) {

        const requestOptions = {
                method: 'POST',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                },
                body: JSON.stringify({
                    Tracker: '74401_retrieveingredient_list_food',
                    user: acctID,
                    xInventoryItemType: item_type,
                    sessionID: sessionID,
                }),
            };
    
            fetch(baseURL + 'hotel_merchantAcct_argsjqApp', requestOptions)
                .then(res => res.text())
                .then(res => {
                    let rows = res.toString().split('~~~');
    
                    for (let rownum = 0; rownum < rows.length - 1; ++rownum) {
                        let cols = rows[rownum].split('|');

                        setViewInventoryAvailableProducts_food((prevAvailableProducts) => {
                            return prevAvailableProducts.concat({
                                ingredientID: cols[0],
                                ingredientName: cols[1],
                                ingredientDescription: cols[2],
                                ingredientPartNum: cols[3],
                                ingredientVendorName: cols[4],
                                ingredientPhoneNumber: cols[5],
                                ingredientAddress: cols[6],
                                ingredientCity: cols[7],
                                ingredientCountry: cols[8],
                                ingredientCostPerUnit: parseFloat(cols[9]).toFixed(2),
                                //ingredientSalePrice: cols[10],
                                ingredientQtyInStock: cols[10],
                                ingredientMeasurementType: parseFloat(cols[11]).toFixed(2),
                                ingredientDateCreated: parseFloat(cols[12]).toFixed(2),
                                ingredientAddedBy: cols[13],
                            });
                        });
                    }
                });
    }
    
    function getItems_drinks(item_type) {

        const requestOptions = {
                method: 'POST',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                },
                body: JSON.stringify({
                    Tracker: '74401_retrieveingredient_list_drinks',
                    user: acctID,
                    xInventoryItemType: item_type,
                    sessionID: sessionID,
                }),
            };
    
            fetch(baseURL + 'hotel_merchantAcct_argsjqApp', requestOptions)
                .then(res => res.text())
                .then(res => {
                    let rows = res.toString().split('~~~');
    
                    for (let rownum = 0; rownum < rows.length - 1; ++rownum) {
                        let cols = rows[rownum].split('|');

                        setViewInventoryAvailableProducts_drinks((prevAvailableProducts) => {
                            return prevAvailableProducts.concat({
                                ingredientID: cols[0],
                                ingredientName: cols[1],
                                ingredientDescription: cols[2],
                                ingredientPartNum: cols[3],
                                ingredientVendorName: cols[4],
                                ingredientPhoneNumber: cols[5],
                                ingredientAddress: cols[6],
                                ingredientCity: cols[7],
                                ingredientCountry: cols[8],
                                ingredientCostPerUnit: parseFloat(cols[9]).toFixed(2),
                                //ingredientSalePrice: cols[10],
                                ingredientQtyInStock: cols[10],
                                ingredientMeasurementType: parseFloat(cols[11]).toFixed(2),
                                ingredientDateCreated: parseFloat(cols[12]).toFixed(2),
                                ingredientAddedBy: cols[13],
                            });
                        });
                    }
                });
    }

    function getItems_hotel(item_type) {

        const requestOptions = {
                method: 'POST',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                },
                body: JSON.stringify({
                    Tracker: '74401_retrieveingredient_list_hotel',
                    user: acctID,
                    xInventoryItemType: item_type,
                    sessionID: sessionID,
                }),
            };
    
            fetch(baseURL + 'hotel_merchantAcct_argsjqApp', requestOptions)
                .then(res => res.text())
                .then(res => {
                    let rows = res.toString().split('~~~');
    
                    for (let rownum = 0; rownum < rows.length - 1; ++rownum) {
                        let cols = rows[rownum].split('|');

                        setViewInventoryAvailableProducts_hotel((prevAvailableProducts) => {
                            return prevAvailableProducts.concat({
                                ingredientID: cols[0],
                                ingredientName: cols[1],
                                ingredientDescription: cols[2],
                                ingredientPartNum: cols[3],
                                ingredientVendorName: cols[4],
                                ingredientPhoneNumber: cols[5],
                                ingredientAddress: cols[6],
                                ingredientCity: cols[7],
                                ingredientCountry: cols[8],
                                ingredientCostPerUnit: parseFloat(cols[9]).toFixed(2),
                                //ingredientSalePrice: cols[10],
                                ingredientQtyInStock: cols[10],
                                ingredientMeasurementType: parseFloat(cols[11]).toFixed(2),
                                ingredientDateCreated: parseFloat(cols[12]).toFixed(2),
                                ingredientAddedBy: cols[13],
                            });
                        });
                    }
                });
    }

    function getItems_misc(item_type) {

        const requestOptions = {
                method: 'POST',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                },
                body: JSON.stringify({
                    Tracker: '74401_retrieveingredient_list_misc',
                    user: acctID,
                    xInventoryItemType: item_type,
                    sessionID: sessionID,
                }),
            };
    
            fetch(baseURL + 'hotel_merchantAcct_argsjqApp', requestOptions)
                .then(res => res.text())
                .then(res => {
                    let rows = res.toString().split('~~~');
    
                    for (let rownum = 0; rownum < rows.length - 1; ++rownum) {
                        let cols = rows[rownum].split('|');

                        setViewInventoryAvailableProducts_misc((prevAvailableProducts) => {
                            return prevAvailableProducts.concat({
                                ingredientID: cols[0],
                                ingredientName: cols[1],
                                ingredientDescription: cols[2],
                                ingredientPartNum: cols[3],
                                ingredientVendorName: cols[4],
                                ingredientPhoneNumber: cols[5],
                                ingredientAddress: cols[6],
                                ingredientCity: cols[7],
                                ingredientCountry: cols[8],
                                ingredientCostPerUnit: parseFloat(cols[9]).toFixed(2),
                                //ingredientSalePrice: cols[10],
                                ingredientQtyInStock: cols[10],
                                ingredientMeasurementType: parseFloat(cols[11]).toFixed(2),
                                ingredientDateCreated: parseFloat(cols[12]).toFixed(2),
                                ingredientAddedBy: cols[13],
                            });
                        });
                    }
                });
    }
    function closeModalHandler(event) {
        setViewInventoryAvailableProducts([]);
        props.closeModal(event);
    }

    function viewInvoiceModalHandler(event) {

        //alert(event);

        setOrderID(event[1]);
        setOrderTotal(event[2]);
        setInvoiceForm(event[3]);
        setViewInvoiceModal(event[0]);

    }

function handleFood()
{
    setViewFood(true);
    setViewFoodBorder('2px solid black');

    setViewDrinks(false);
    setViewDrinkBorder('none');

    setViewHotel(false);
    setViewHotelBorder('none');

    setViewMisc(false);
    setViewMiscBorder('none');
}
function handleDrink()
{
    setViewFood(false);
    setViewFoodBorder('none');

    setViewDrinks(true);
    setViewDrinkBorder('2px solid black');

    setViewHotel(false);
    setViewHotelBorder('none');

    setViewMisc(false);
    setViewMiscBorder('none');
}

function handleHotel()
{
    setViewFood(false);
    setViewFoodBorder('none');

    setViewDrinks(false);
    setViewDrinkBorder('none');

    setViewHotel(true);
    setViewHotelBorder('2px solid black');

    setViewMisc(false);
    setViewMiscBorder('none');
}

function handleMisc()
{
    setViewFood(false);
    setViewFoodBorder('none');

    setViewDrinks(false);
    setViewDrinkBorder('none');

    setViewHotel(false);
    setViewHotelBorder('none');

    setViewMisc(true);
    setViewMiscBorder('2px solid black');
}

function showItemDetailsModalHandler(event)
{
    setIngredientID(event[1]);
    setIngredientName(event[2]);
    setShowItemDetails(true);
}
    
useEffect(() =>  {
        
    getItems_food("FOOD"); 

    getItems_drinks("DRINKS");   

    getItems_hotel("HOTEL"); 

    getItems_misc("MISC"); 

}, [])
    
    return (
        <React.Fragment>
                    
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonHeader style={{color: "black"}}>
                <IonGrid>
                    <IonRow>
                        <IonCol size='3' style={{border: viewFoodBorder}} onClick={() => handleFood()}>
                            <IonText> FOOD </IonText>
                        </IonCol>
                        <IonCol size='3' style={{border: viewDrinkBorder}} onClick={() => handleDrink()}>
                            <IonText> DRINK </IonText>
                        </IonCol>
                        <IonCol size='3' style={{border: viewHotelBorder}} onClick={() => handleHotel()}>
                            <IonText> Hotel </IonText>
                        </IonCol>
                        <IonCol size='3' style={{border: viewMiscBorder}} onClick={() => handleMisc()}>
                            <IonText> Misc </IonText>
                        </IonCol>
                    </IonRow>
                    <IonRow style={{border: '2px solid black' }}>
                        <IonCol size='2'>
                            <h5> ID </h5>
                        </IonCol>
                        <IonCol size='6'>
                            <h5> Name </h5>
                        </IonCol>
                        {/*<IonCol size='3'>
                            <h5> Cost </h5>
                        </IonCol>*/}
                        <IonCol size='2'>
                            <h5> Stock </h5>
                        </IonCol>
                        <IonCol size='2'>
                            <h5> Action </h5>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonHeader>
            <IonContent className='grid_content'>
            <IonGrid >
                    {viewFood == true &&

                            viewInventoryAvailableProducts_food.map((detailData) => {
                                return (
                                    <IonRow key={detailData.ingredientID}>
                                        <IonCol size='2'>{detailData.ingredientID}</IonCol>
                                        <IonCol size='6'>{detailData.ingredientName}</IonCol>
                                        {/*<IonCol size='3'>{detailData.ingredientCostPerUnit}</IonCol>*/}
                                        <IonCol size='2'>{detailData.ingredientQtyInStock}</IonCol>
                                        <IonCol size='2'>
                                            <IonButton onClick={() => showItemDetailsModalHandler([true, detailData.ingredientID, detailData.ingredientName])}>Details</IonButton>
                                        </IonCol>
                                    </IonRow>
                                );
                            })
                    }
                        
                    {viewDrinks == true &&

                            viewInventoryAvailableProducts_drinks.map((detailData) => {
                                return (
                                    <IonRow key={detailData.ingredientID}>
                                        <IonCol size='2'>{detailData.ingredientID}</IonCol>
                                        <IonCol size='6'>{detailData.ingredientName}</IonCol>
                                        {/*<IonCol size='3'>{detailData.ingredientCostPerUnit}</IonCol>*/}
                                        <IonCol size='2'>{detailData.ingredientQtyInStock}</IonCol>
                                        <IonCol size='2'>
                                            <IonButton onClick={() => showItemDetailsModalHandler([true, detailData.ingredientID, detailData.ingredientName])}>Details</IonButton>
                                        </IonCol>
                                    </IonRow>
                                );
                            })
                    }
                    
                    {viewHotel == true &&

                            viewInventoryAvailableProducts_hotel.map((detailData) => {
                                return (
                                    <IonRow key={detailData.ingredientID}>
                                        <IonCol size='2'>{detailData.ingredientID}</IonCol>
                                        <IonCol size='6'>{detailData.ingredientName}</IonCol>
                                        {/*<IonCol size='3'>{detailData.ingredientCostPerUnit}</IonCol>*/}
                                        <IonCol size='2'>{detailData.ingredientQtyInStock}</IonCol>
                                        <IonCol size='2'>
                                            <IonButton onClick={() => showItemDetailsModalHandler([true, detailData.ingredientID, detailData.ingredientName])}>Details</IonButton>
                                        </IonCol>
                                    </IonRow>
                                );
                            })
                    }
                    
                    {viewMisc == true &&

                            viewInventoryAvailableProducts_misc.map((detailData) => {
                                return (
                                    <IonRow key={detailData.ingredientID}>
                                        <IonCol size='2'>{detailData.ingredientID}</IonCol>
                                        <IonCol size='6'>{detailData.ingredientName}</IonCol>
                                        {/*<IonCol size='3'>{detailData.ingredientCostPerUnit}</IonCol>*/}
                                        <IonCol size='2'>{detailData.ingredientQtyInStock}</IonCol>
                                        <IonCol size='2'>
                                            <IonButton onClick={() => showItemDetailsModalHandler([true, detailData.ingredientID, detailData.ingredientName])}>Details</IonButton>
                                        </IonCol>
                                    </IonRow>
                                );
                            })
                        }
                    
                        </IonGrid>

            {showItemDetails == true &&  <ViewItemDetailDataModal openModal={ showItemDetails } closeModal={() => setShowItemDetails(false)} data={{
                                    itemID: ingredientID, 
                                    itemName: ingredientName
                                    }}>
                                </ViewItemDetailDataModal>}
            </IonContent>
            <IonFooter class='grid_footer'>
                <IonGrid>
                    <IonRow>
                        <IonCol size="12">
                            <IonButton onClick={() => closeModalHandler()}>Cancel </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
        </IonFooter>
        </IonModal>
        ) : null}
    
        </React.Fragment>

    )
}